import React, { useId } from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label?: string;
  icon?: React.ReactElement;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { id, label, icon, ...props },
  ref
) {
  const backupId = useId();

  return (
    <div>
      {label && (
        <label
          className="subtitle mb-4 text-base font-semibold"
          htmlFor={id ?? backupId}
        >
          {label}
        </label>
      )}
      <span className="relative inline-block w-full">
        <input
          {...props}
          id={id ?? backupId}
          className={`block max-h-[3.5em] min-h-[3.5em] w-full rounded-md border border-solid border-primary-200 bg-white p-4 ${
            icon ? "pr-9" : ""
          } text-left transition placeholder:italic placeholder:text-gray-500 hover:border-primary hover:bg-primary-50 focus:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-75 ${
            props.className ?? ""
          }`}
          ref={ref}
        />
        {icon && (
          <div className="pointer-events-none absolute right-2 top-0 h-full">
            <div className="flex h-full items-center">{icon}</div>
          </div>
        )}
      </span>
    </div>
  );
});

export { Input };
